import Styled, { css } from 'styled-components';

import { FONT_MAP, media } from '../../lib/StyledComponents';
import { VALID_HEADLINE_SCALE } from '../../lib/StyledComponents/Theme/common';

export interface IHeadlineProps {
  // tslint:disable no-reserved-keywords no-any
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  scale: VALID_HEADLINE_SCALE;
}

export const Headline = Styled.h4<IHeadlineProps>`
  font-size: ${({ theme: { headline }, scale }) => headline[scale].sizeResponsive};
  line-height: ${({ theme: { headline }, scale }) => headline[scale].lineHeightResponsive};
  font-weight: ${({ theme: { headline }, scale }) => headline[scale].weight};
  color: ${({ theme: { headline }, scale }) => headline[scale].colorText};
  font-family: ${({ theme: { headline }, scale }) => FONT_MAP[headline[scale].displayTypeface]};
  letter-spacing: ${({ theme: { headline }, scale }) => headline[scale].letterSpacing};

  ${props => css`
    ${media.small`
      font-size: ${props.theme.headline[props.scale].size};
      line-height: ${props.theme.headline[props.scale].lineHeight};
    `}
  `}
`;

Headline.displayName = 'Headline';
Headline.defaultProps = {
  scale: 'small',
};
